import { render, staticRenderFns } from "./UserGroupList.vue?vue&type=template&id=13f58060&scoped=true"
import script from "./UserGroupList.vue?vue&type=script&lang=js"
export * from "./UserGroupList.vue?vue&type=script&lang=js"
import style0 from "./UserGroupList.vue?vue&type=style&index=0&id=13f58060&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13f58060",
  null
  
)

export default component.exports